/**
 * Licenza MUI X Pro (DataGridPro).
 * La chiave è pubblica per design (finisce comunque nel bundle client), quindi va bene committarla qui.
 * Usata da apps/company e apps/payroll (main.jsx) via LicenseInfo.setLicenseKey().
 */
export const MUI_LICENSE_KEY = '25d9f1c24409d0bc93ca44b677e6e67cTz0xMjIyMjAsRT0xNzk1NDc4Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';